import React from 'react'
import { Box, Typography } from 'transfix-ui/core'
import { Button, TAG_STYLE } from 'transfix-ui'
import { capitalize } from 'utils/capitalize'
import { IInsurancePolicyFragment } from '../graphql/InsurancePoliciesFragment'
import { getLabel } from '../utils'
import EffectiveDateTag from './EffectiveDateTag'

interface IInsuranceTableRow {
  insurancePolicy: IInsurancePolicyFragment
}

const InsuranceTabRowArchived = ({ insurancePolicy }: IInsuranceTableRow) => {
  const { effectiveDate, expirationDate, insuranceCertificate, isType } = insurancePolicy || {}
  const { signedUrl } = insuranceCertificate || {}

  const documentsValue = signedUrl ? (
    <Box>
      <Button href={signedUrl} target='_blank' variant='text'>
        Certificate of Insurance
      </Button>
    </Box>
  ) : (
    'No Data'
  )

  const formattedType = getLabel(isType) || capitalize(isType?.replaceAll('_', ' ') || '')

  return (
    <Box display='flex' justifyContent='space-between' alignItems='center' mb={3}>
      <Box flex='1 1 0'>
        <Typography variant='caption' color='textSecondary'>
          {formattedType}
        </Typography>
      </Box>
      <Box flex='1 1 0'>
        <Typography>{documentsValue}</Typography>
      </Box>
      <EffectiveDateTag
        tagStyle={TAG_STYLE.dark}
        effectiveDate={effectiveDate}
        expirationDate={expirationDate}
      />
    </Box>
  )
}
export default InsuranceTabRowArchived
